import React, { useEffect } from "react";
import styles from "./ReceiptPage.module.css";
import environment from "environment";
import { AccountContainer } from "hooks/useAccount";

export function ReceiptPage() {
  const { glacierTransactionPost } = AccountContainer.useContainer();

  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  const checkout_id = new URLSearchParams(window.location.search).get('checkout_id');
  const order_id = new URLSearchParams(window.location.search).get('order_id');

  useEffect(() => {
    //post checkout_id and order_id to the API
    const postData = async () => {
      try {
        const response = await glacierTransactionPost(order_id, checkout_id);

        if (response?.body?.success === true) {
          //show Thank you message
          setLoading(false);
        }
      }
      catch (error) {
        setError(error);
        setLoading(false);
        console.error('Error posting transaction data:', error);
      }
    }
    if (checkout_id && order_id) {
      postData().then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setError(error);
        setLoading(false);
        console.error('Error in postData:', error);
      });
    } else {
      console.error('Missing checkout_id or order_id in URL');
    }
  }, []);

  return (
    <>
      {loading && <div className={styles.loading}>Processing your payment...</div>}
      {error && <div className={styles.error}>Error: {error.message}</div>}
      {!loading && !error &&

        <div>
          <h1 className={styles.title}>Thank You!</h1>
          <p className={styles.message}>
            Your payment has been successfully processed.
            A confirmation email has been sent to your registered email address.
          </p>
          <p className={styles.info}>
            If you have any questions, please contact us at
            <a href={`mailto:${environment.supportEmail}`}>{environment.supportEmail}</a>.
          </p>
          <p className={styles.info}>
            You can return to the <a href={environment.homeUrl}>home page</a>.
          </p>
        </div>}
    </>)
}

export default ReceiptPage;
